export default __webpack_public_path__ + "5dcb014d8df03aba7452ce688d07ed41.png";